import {Shop} from './Shop';
import {SignIn} from './SignIn';
import {Filter} from './Filter';
import {SignUp} from './SignUp';
import {Home} from './tabs/Home';
import {Product} from './Product';
import {SignOut} from './SignOut';
import {Reviews} from './Reviews';
import {Order} from './tabs/Order';

import {Checkout} from './Checkout';
import {InfoSaved} from './InfoSaved';
import {Profile} from './tabs/Profile';
import {Wishlist} from './tabs/Wishlist';
import {OrderFailed} from './OrderFailed';
import {NewPassword} from './NewPassword';
import {EditProfile} from './EditProfile';
import {Description} from './Description';
import {CartEmpty} from './tabs/CartEmpty';
import {MyPromocodes} from './MyPromocodes';
import {OrderHistory} from './OrderHistory';
import {LeaveAReview} from './LeaveAReview';
import {Categories} from './tabs/Categories';
import {DeleteAccount} from './DeleteAccount';
import {ForgotPassword} from './ForgotPassword';
import {OrderSuccessful} from './OrderSuccessful';
import {WishlistEmpty} from './tabs/WishlistEmpty';
import {MyPromocodesEmpty} from './MyPromocodesEmpty';
import {OrderHistoryEmpty} from './OrderHistoryEmpty';
import {Verification} from './verification/Verification';
import {SendPhoneOtp} from './verification/SendPhoneOtp';
import {SendEmailOtp} from './verification/SendEmailOtp';
import {PhoneVerified} from './verification/PhoneVerified';
import {EmailVerified} from './verification/EmailVerified';
import {SignUpAccountCreated} from './SignUpAccountCreated';
import {ShippingAndPaymentInfo} from './ShippingAndPaymentInfo';
import {ForgotPasswordSentEmail} from './ForgotPasswordSentEmail';
import {ShopHome} from './ShopHome';

export const screens = {
  Home,
  Shop,
  ShopHome,
  Order,
  SignUp,
  SignIn,
  Filter,
  Profile,
  Product,
  Reviews,
  SignOut,
  Checkout,
  Wishlist,
  CartEmpty,
  InfoSaved,
  Categories,
  Description,
  EditProfile,
  OrderFailed,
  NewPassword,
  OrderHistory,
  SendEmailOtp,
  MyPromocodes,
  SendPhoneOtp,
  LeaveAReview,
  Verification,
  DeleteAccount,
  PhoneVerified,
  WishlistEmpty,
  EmailVerified,
  ForgotPassword,
  OrderSuccessful,
  OrderHistoryEmpty,
  MyPromocodesEmpty,
  SignUpAccountCreated,
  ShippingAndPaymentInfo,
  ForgotPasswordSentEmail,
};
